import { Item, GridStats } from "../types";



/**
 * da una serie di Item restituisce le statistiche
 * negli ITEMS i totali sono già stati calcolati
 */
export function getStats(items: Item[], valueIndex: number): GridStats {
	let stats = { total: 0, average: 0, max: 0, min: 0 };
	stats = items?.reduce<GridStats>((acc, item, i) => {
		const value = item.totals?.[valueIndex] ?? 0;
		acc.total += value;
		acc.max = Math.max(acc.max, value);
		acc.min = Math.min(acc.min, value);
		acc.average = acc.total / (i + 1);
		return acc;
	}, stats) ?? stats;
	return stats;
}

export function getStatsByData(data: any[], propName: string): GridStats {
	let stats = { total: 0, average: 0, max: 0, min: 0 };
	stats = data?.reduce<GridStats>((acc, data, i) => {
		const value = data[propName] ?? 0;
		acc.total += value;
		acc.max = Math.max(acc.max, value);
		acc.min = Math.min(acc.min, value);
		acc.average = acc.total / (i + 1);
		return acc;
	}, stats) ?? stats;
	return stats;
}

/**
 * unisce due insiemi di statistiche
 */
export function mergeStats(stats1: GridStats, stats2: GridStats): GridStats {
	return {
		total: stats1.total + stats2.total,
		average: (stats1.total + stats2.total) / 2,
		max: Math.max(stats1.max, stats2.max),
		min: Math.min(stats1.min, stats2.min)
	};
}
